import { Fragment, cloneElement, useState } from "react";
import {
  FloatingPortal,
  autoPlacement,
  offset,
  shift,
  useDismiss,
} from "@floating-ui/react";
import {
  useFloating,
  useInteractions,
  useTransitionStyles,
} from "@floating-ui/react";

export const Dropdown = ({ children, className = "", awake = false }) => {
  // FLOATING LOGIC
  const [isOpen, setIsOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [
      offset(24),
      shift(),
      autoPlacement({
        autoAlignment: true,
        allowedPlacements: ["top", "bottom"],
      }),
    ],
  });

  // DISMISS LOGIC
  const dismiss = useDismiss(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss]);

  // TRANSITION LOGIC
  const { styles } = useTransitionStyles(context, {
    initial: {
      opacity: 0,
      transform: "scale(0.8)",
    },
    closed: {
      opacity: 0,
      transform: "scale(0.8)",
    },
  });

  // CLICK INSIDE LOGIC
  const handleClickInside = () => {
    if (awake) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  const triggerChild = children?.at(0);
  const asChild = triggerChild?.props?.asChild;

  return (
    <Fragment>
      {asChild ? (
        cloneElement(triggerChild, {
          ...getReferenceProps(),
          ref: refs.setReference,
          onClick: (e) => {
            setIsOpen((prev) => !prev);
            triggerChild.props.onClick?.(e);
          },
        })
      ) : (
        <button
          {...getReferenceProps()}
          className={`outline-none ${className}`}
          ref={refs.setReference}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {triggerChild}
        </button>
      )}
      {isOpen && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            style={{ ...floatingStyles }}
            className="z-[70]"
            {...getFloatingProps}
          >
            <div style={{ ...styles }} onClick={handleClickInside}>
              {children?.at(1)}
            </div>
          </div>
        </FloatingPortal>
      )}
    </Fragment>
  );
};

export const DropdownTrigger = ({ children }) => {
  return children;
};

export const DropdownContent = ({ children }) => {
  return children;
};

export const DropdownItem = ({
  children,
  className = "",
  onClick,
  disabled,
}) => {
  return (
    <button
      className={`relative w-full py-[4px] px-[8px] text-start ${className} ${
        disabled ? "text-grey" : "hover:bg-gray-100 hover:text-black"
      }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
